// Base paths
const accountsPath = '/accounts'
const newAccountPath = `${accountsPath}/new`
const accountPath = `${accountsPath}/:accountID`
const accountTabPath = `${accountPath}/:activeTab`

const connectionsPath = `${accountPath}/connections`
const connectionPath = `${connectionsPath}/:connectionID`
const connectionTabPath = `${connectionPath}/:activeTab`

const usersPath = `${accountPath}/users`
const userPath = `${usersPath}/:userID`
const userTabPath = `${userPath}/:activeTab`

const userConnectionsPath = `${userPath}/connections`
const userConnectionPath = `${userConnectionsPath}/:connectionID`
const userConnectionTabPath = `${userConnectionPath}/:activeTab`

const userGroupsPath = `${accountPath}/groups`
const userGroupPath = `${userGroupsPath}/:groupID`
const userGroupTabPath = `${userGroupPath}/:activeTab`

const userGroupConnectionsPath = `${userGroupPath}/connections`
const userGroupConnectionPath = `${userGroupConnectionsPath}/:connectionID`
const userGroupConnectionTabPath = `${userGroupConnectionPath}/:activeTab`

const reportTemplatesPath = `${accountPath}/reporttemplates`
const reportTemplatePath = `${reportTemplatesPath}/:reportCode`
const reportTemplateTabPath = `${reportTemplatePath}/:activeTab`

const accountReportTemplates = reportTemplatesPath
const accountReportTemplatePath = reportTemplatePath
const accountReportTemplateTabPath = reportTemplateTabPath

const userGroupReportTemplates = `${userGroupPath}/reporttemplates`
const userGroupReportTemplatePath = `${userGroupReportTemplates}/:reportCode`
const userGroupReportTemplateTabPath = `${userGroupReportTemplatePath}/:activeTab`

// Builder functions
function accountPathForAccount(accountID) {
  return `/accounts/${accountID}`
}

function accountTabPathForAccount(accountID, tab) {
  return `${accountPathForAccount(accountID)}/${tab}`
}

function connectionPathForConnection(accountID, connectionID) {
  return `${accountPathForAccount(accountID)}/connections/${connectionID}`
}

function connectionsPathForAccount(accountID) {
  return `${accountPathForAccount(accountID)}/connections`
}

function usersPathForAccount(accountID) {
  return `${accountPathForAccount(accountID)}/users`
}

function userPathForUser(accountID, userID) {
  return `${usersPathForAccount(accountID)}/${userID}`
}

function userConnectionsPathForUser(accountID, userID) {
  return `${userPathForUser(accountID, userID)}/connections`
}

function userConnectionPathForUserConnection(accountID, userID, connectionID) {
  return `${userPathForUser(accountID, userID)}/connections/${connectionID}`
}

function userGroupsPathForAccount(accountID) {
  return `${accountPathForAccount(accountID)}/groups`
}

function userGroupPathForUserGroup(accountID, groupID) {
  return `${userGroupsPathForAccount(accountID)}/${groupID}`
}

function userGroupConnectionsPathForUserGroup(accountID, groupID) {
  return `${userGroupPathForUserGroup(accountID, groupID)}/connections`
}

function userGroupConnectionPathForUserGroupConnection(
  accountID,
  groupID,
  connectionID,
) {
  return `${userGroupConnectionsPathForUserGroup(
    accountID,
    groupID,
  )}/${connectionID}`
}

function reportTemplatesPathForAccount(accountID) {
  return `${accountPathForAccount(accountID)}/reporttemplates`
}

function reportTemplatePathForAccount(accountID, reportTemplateCode) {
  return `${reportTemplatesPathForAccount(accountID)}/${reportTemplateCode}`
}

function reportTemplatePathForReportTemplate(
  accountID,
  userGroupID,
  reportTemplateCode,
) {
  return `${userGroupPathForUserGroup(
    accountID,
    userGroupID,
  )}/reporttemplates/${reportTemplateCode}`
}

function userGroupReportTemplatesPathForUserGroup(accountID, groupID) {
  return `${userGroupPathForUserGroup(accountID, groupID)}/reporttemplates`
}

function userGroupReportTemplatePathForUserGroupReportTemplate(
  accountID,
  userGroupID,
  reportTemplateCode,
) {
  return `${userGroupReportTemplatesPathForUserGroup(
    accountID,
    userGroupID,
  )}/${reportTemplateCode}`
}

// Export everything
export {
  accountsPath,
  newAccountPath,
  accountPath,
  accountTabPath,
  connectionPath,
  connectionTabPath,
  connectionsPath,
  userGroupsPath,
  userGroupPath,
  userGroupTabPath,
  userGroupConnectionsPath,
  userGroupConnectionPath,
  userGroupConnectionTabPath,
  usersPath,
  userPath,
  userTabPath,
  userConnectionsPath,
  userConnectionPath,
  userConnectionTabPath,
  reportTemplatesPath,
  reportTemplatePath,
  reportTemplateTabPath,
  accountReportTemplates,
  accountReportTemplatePath,
  accountReportTemplateTabPath,
  userGroupReportTemplates,
  userGroupReportTemplatePath,
  userGroupReportTemplateTabPath,
  // builder functions
  accountPathForAccount,
  accountTabPathForAccount,
  connectionPathForConnection,
  connectionsPathForAccount,
  usersPathForAccount,
  userPathForUser,
  userConnectionsPathForUser,
  userConnectionPathForUserConnection,
  userGroupsPathForAccount,
  userGroupPathForUserGroup,
  userGroupConnectionsPathForUserGroup,
  userGroupConnectionPathForUserGroupConnection,
  reportTemplatesPathForAccount,
  reportTemplatePathForAccount,
  reportTemplatePathForReportTemplate,
  userGroupReportTemplatesPathForUserGroup,
  userGroupReportTemplatePathForUserGroupReportTemplate,
}
